import { RequiredTheme, ResponsiveValue, system, Theme } from 'styled-system';

export const FontFamilyOptionsArray = ['ProximaNova', 'Arial', 'sans-serif'] as const;
export type FontFamilyOptions = (typeof FontFamilyOptionsArray)[number];

export const fontFamily = system({
    fontFamily: true,
});

export interface FontFamilyProps<ThemeType extends Theme = RequiredTheme> {
    fontFamily?: ResponsiveValue<FontFamilyOptions, ThemeType> | undefined;
}
